var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeatTreatmentParam"},[(_vm.nowPage == '即時參數顯示')?void 0:(_vm.nowPage == '歷史參數查詢')?[_c('heatTreatmentInquire')]:(_vm.nowPage == '統計分析')?[_c('heatTreatmentAnalysis')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd0bc7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HeatTreatmentParam.vue
// module id = null
// module chunks = 